export enum ProductionMethod {
	CONVENTIONAL = 'CONVENTIONAL',
	IPM = 'IPM',
	ORGANIC = 'ORGANIC',
}

export type TProductionMethod = keyof typeof ProductionMethod;
